// @ts-nocheck
import { makeStyles } from '@material-ui/core';

export const useAttachmentStyles = makeStyles({
  attachmentsContainer: {
    position: 'relative',
    margin: '12px 10px 0 0',
    '&:hover $onHover': {
      opacity: 1,
    },
  },
  attachment: {
    height: 300,
    width: 300,
    borderRadius: '4px',
    marginRight: '12px',
    boxShadow:
      ' 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
  },
  attachmentIcon: {
    position: 'absolute',
    top: '5px',
    left: '15px',
  },
  fileIcon: {
    color: '#F44336',
    fontSize: '18px',
  },
  fileName: {
    fontSize: '8px',
    position: 'absolute',
    top: '25px',
    left: '8px',
    padding: '0px 5px',
    color: '#6A737B',
    maxWidth: '120px',
  },
  imageName: {
    color: '#ffffff',
    position: 'absolute',
    fontSize: '8px',
    top: '10px',
    left: '8px',
    maxWidth: '120px',
  },
  iconButtonContainer: {
    marginRight: '8px',
    display: 'inline-block',
  },
  actionIcon: {
    fontSize: '12px',
    color: '#5F6D83',
  },
  actionIconButton: {
    width: '18px',
    height: '18px',
    background: 'rgba(255, 255, 255, 0.8) !important',
    borderRadius: '4px !important',
    padding: '4px !important',
  },
  onHover: {
    opacity: 0,
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35))',
    position: 'absolute',
    top: 0,
    width: 300,
    left: 0,
    height: 300,
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
});
